import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

import { BackupOriginatorGlobalNav } from '~/backup/originator/domains/page/ui/BackupOriginatorGlobalNav';
import { BackupDealNav } from '~/backup/shared/deal-nav/BackupDealNav';
import { useDealRouteMatch } from '~/backup/shared/deal-nav/useDealRouteMatch';
import { AppHeader } from '~/packages/common-frontend/layout/Header';

type Props = { children: React.ReactNode };
export const BackupOriginatorTemplate = ({
  children,
}: Props): React.ReactElement => {
  // On a deal route, swap the flat portal nav for the deal-scoped sidebar. The
  // originator has no Portfolio/Strats index yet, so the back-link points at
  // the Data Pipeline and Strats is hidden.
  const deal = useDealRouteMatch();
  return (
    <>
      <AppHeader />
      <Flex grow={1} pt="84px">
        {deal ? (
          <BackupDealNav
            implementationId={deal.implementationId}
            subPath={deal.subPath}
            backTo="/data-pipeline"
            backLabel="Data Pipeline"
            showStrats={false}
            showSettings={false}
          />
        ) : (
          <BackupOriginatorGlobalNav />
        )}
        <Box width="100%" overflowX="auto">
          {children}
        </Box>
      </Flex>
    </>
  );
};
